// extracted by mini-css-extract-plugin
export default {"cta":"YH-z","disabled":"ZH-z"};